const KEY = 'pay888.pendingReferral';
const TTL = 7 * 24 * 60 * 60 * 1000;
export function clearPendingReferral(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* Storage is optional. */
  }
}
export function readPendingReferral(): string | null {
  try {
    const value: unknown = JSON.parse(sessionStorage.getItem(KEY) ?? 'null');
    if (
      typeof value === 'object' &&
      value !== null &&
      'code' in value &&
      'at' in value &&
      typeof value.code === 'string' &&
      /^[a-f0-9]{24}$/.test(value.code) &&
      typeof value.at === 'number' &&
      Date.now() >= value.at &&
      Date.now() - value.at < TTL
    )
      return value.code;
  } catch {
    /* Invalid or unavailable storage never blocks sign-in. */
  }
  clearPendingReferral();
  return null;
}
export function captureReferral(search: string): void {
  const codes = new URLSearchParams(search).getAll('ref');
  if (codes.length !== 1 || !/^[a-f0-9]{24}$/.test(codes[0]) || readPendingReferral()) return;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ code: codes[0], at: Date.now() }));
  } catch {
    /* Storage is optional. */
  }
}
